import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Container, Button, Modal, Form, Alert, Row, Col } from 'react-bootstrap';

const AdminProducts = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');
  const [show, setShow] = useState(false);
  const [showQuickEdit, setShowQuickEdit] = useState(false);
  const [quickEditText, setQuickEditText] = useState('');

  const [currentProduct, setCurrentProduct] = useState({
    productId: '',
    name: '',
    description: '',
    price: '',
    category: '',
    series: '',
    sizes: [],
    members: [],
    images: [],
    status: true,
  });

  const fetchProducts = async () => {
    document.title = '產品管理';
    try {
      const response = await axios.get('https://shopapi.nogi46.me/api/products/manage');
      setProducts(response.data);
    } catch (error) {
      setError('無法獲取產品，請稍後再試。');
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get('https://shopapi.nogi46.me/api/categories');
      setCategories(response.data);
    } catch (error) {
      setError('無法獲取分類，請稍後再試。');
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, []);

  const handleShow = (product) => {
    setCurrentProduct(product || {
      productId: '',
      name: '',
      description: '',
      price: '',
      category: '',
      series: '',
      sizes: [],
      members: [],
      images: [],
      status: true,
    });
    setShow(true);
  };

  const handleClose = () => setShow(false);

  const handleSave = async () => {
    try {
      const token = localStorage.getItem('token');
      if (currentProduct.productId) {
        // 更新產品
        await axios.put(`https://shopapi.nogi46.me/api/products/${currentProduct.productId}`, currentProduct, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      } else {
        // 添加新產品
        await axios.post('https://shopapi.nogi46.me/api/products', currentProduct, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      }
      fetchProducts();
      handleClose();
    } catch (error) {
      setError('無法保存產品，請稍後再試。');
    }
  };

  const handleDelete = async (productId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`https://shopapi.nogi46.me/api/products/${productId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      fetchProducts();
    } catch (error) {
      setError('無法刪除產品，請稍後再試。');
    }
  };

  const handleAddSize = () => {
    setCurrentProduct({ ...currentProduct, sizes: [...currentProduct.sizes, ''] });
  };

  const handleRemoveSize = (index) => {
    const newSizes = [...currentProduct.sizes];
    newSizes.splice(index, 1);
    setCurrentProduct({ ...currentProduct, sizes: newSizes });
  };

  const handleSizeChange = (index, value) => {
    const newSizes = [...currentProduct.sizes];
    newSizes[index] = value;
    setCurrentProduct({ ...currentProduct, sizes: newSizes });
  };

  const handleAddMember = () => {
    setCurrentProduct({ ...currentProduct, members: [...currentProduct.members, ''] });
  };

  const handleRemoveMember = (index) => {
    const newMembers = [...currentProduct.members];
    newMembers.splice(index, 1);
    setCurrentProduct({ ...currentProduct, members: newMembers });
  };

  const handleMemberChange = (index, value) => {
    const newMembers = [...currentProduct.members];
    newMembers[index] = value;
    setCurrentProduct({ ...currentProduct, members: newMembers });
  };

  const handleQuickEdit = () => {
    setQuickEditText(currentProduct.members.join('\n'));
    setShowQuickEdit(true);
  };

  const handleQuickEditSave = () => {
    const newMembers = quickEditText.split('\n').filter(member => member.trim() !== '');
    setCurrentProduct({ ...currentProduct, members: newMembers });
    setShowQuickEdit(false);
  };

  const handleAddImage = () => {
    setCurrentProduct({ ...currentProduct, images: [...currentProduct.images, ''] });
  };

  const handleRemoveImage = (index) => {
    const newImages = [...currentProduct.images];
    newImages.splice(index, 1);
    setCurrentProduct({ ...currentProduct, images: newImages });
  };

  const handleImageChange = (index, value) => {
    const newImages = [...currentProduct.images];
    newImages[index] = value;
    setCurrentProduct({ ...currentProduct, images: newImages });
  };

  return (
    <Container>
      <h1>產品管理</h1>
      {error && <Alert variant="danger">{error}</Alert>}
      <Button variant="primary" onClick={() => handleShow()}>添加產品</Button>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>ID</th>
            <th>名稱</th>
            <th>描述</th>
            <th>價格</th>
            <th>分類</th>
            <th>狀態</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <tr key={product.productId}>
              <td>{product.productId}</td>
              <td>{product.name}</td>
              <td>{product.description}</td>
              <td>${product.price}</td>
              <td>{product.category}</td>
              <td>{product.status ? '在售' : '下架'}</td>
              <td>
                <Button variant="secondary" onClick={() => handleShow(product)}>編輯</Button>{' '}
                <Button variant="danger" onClick={() => handleDelete(product.productId)}>刪除</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{currentProduct.productId ? '編輯產品' : '添加產品'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="productId">
              <Form.Label>產品ID</Form.Label>
              <Form.Control
                type="text"
                value={currentProduct.productId}
                readOnly
              />
            </Form.Group>
            <Form.Group controlId="productName">
              <Form.Label>名稱</Form.Label>
              <Form.Control
                type="text"
                value={currentProduct.name}
                onChange={(e) => setCurrentProduct({ ...currentProduct, name: e.target.value })}
              />
            </Form.Group>
            <Form.Group controlId="productDescription">
              <Form.Label>描述</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={currentProduct.description}
                onChange={(e) => setCurrentProduct({ ...currentProduct, description: e.target.value })}
              />
            </Form.Group>
            <Form.Group controlId="productPrice">
              <Form.Label>價格</Form.Label>
              <Form.Control
                type="number"
                value={currentProduct.price}
                onChange={(e) => setCurrentProduct({ ...currentProduct, price: e.target.value })}
              />
            </Form.Group>
            <Form.Group controlId="productCategory">
              <Form.Label>分類</Form.Label>
              <Form.Control
                as="select"
                value={currentProduct.category}
                onChange={(e) => setCurrentProduct({ ...currentProduct, category: e.target.value })}
              >
                <option value="">選擇分類</option>
                {categories.map((category) => (
                  <option key={category.categoryId} value={category.categoryId}>{category.name}</option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="productSeries">
              <Form.Label>系列</Form.Label>
              <Form.Control
                as="select"
                value={currentProduct.series}
                onChange={(e) => setCurrentProduct({ ...currentProduct, series: e.target.value })}
              >
                <option value="">請選擇</option>
                <option value="N">N</option>
                <option value="H">H</option>
                <option value="S">S</option>
                <option value="O">O</option>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="productSizes">
              <Form.Label>尺寸</Form.Label>
              {currentProduct.sizes.map((size, index) => (
                <Row key={index} className="mb-2">
                  <Col>
                    <Form.Control
                      type="text"
                      value={size}
                      onChange={(e) => handleSizeChange(index, e.target.value)}
                    />
                  </Col>
                  <Col xs="auto">
                    <Button variant="danger" onClick={() => handleRemoveSize(index)}>移除</Button>
                  </Col>
                </Row>
              ))}
              <Button variant="primary" onClick={handleAddSize}>添加尺寸</Button>
            </Form.Group>
            <Form.Group controlId="productMembers">
              <Form.Label>成員</Form.Label>
              {currentProduct.members.map((member, index) => (
                <Row key={index} className="mb-2">
                  <Col>
                    <Form.Control
                      type="text"
                      value={member}
                      onChange={(e) => handleMemberChange(index, e.target.value)}
                    />
                  </Col>
                  <Col xs="auto">
                    <Button variant="danger" onClick={() => handleRemoveMember(index)}>移除</Button>
                  </Col>
                </Row>
              ))}
              <Button variant="primary" onClick={handleAddMember}>添加成員</Button>{' '}
              <Button variant="secondary" onClick={handleQuickEdit}>快速編輯</Button>
            </Form.Group>
            <Form.Group controlId="productImages">
              <Form.Label>圖片</Form.Label>
              {currentProduct.images.map((image, index) => (
                <Row key={index} className="mb-2">
                  <Col>
                    <Form.Control
                      type="text"
                      value={image}
                      onChange={(e) => handleImageChange(index, e.target.value)}
                    />
                  </Col>
                  <Col xs="auto">
                    <Button variant="danger" onClick={() => handleRemoveImage(index)}>移除</Button>
                  </Col>
                </Row>
              ))}
              <Button variant="primary" onClick={handleAddImage}>添加圖片</Button>
            </Form.Group>
            <Form.Group controlId="productStatus">
              <Form.Check
                type="checkbox"
                label="在售"
                checked={currentProduct.status}
                onChange={(e) => setCurrentProduct({ ...currentProduct, status: e.target.checked })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>取消</Button>
          <Button variant="primary" onClick={handleSave}>保存</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showQuickEdit} onHide={() => setShowQuickEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>快速編輯成員</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="quickEditMembers">
            <Form.Label>成員</Form.Label>
            <Form.Control
              as="textarea"
              rows={10}
              value={quickEditText}
              onChange={(e) => setQuickEditText(e.target.value)}
            />
            <Form.Text className="text-muted">每行一個成員名稱。</Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowQuickEdit(false)}>取消</Button>
          <Button variant="primary" onClick={handleQuickEditSave}>保存</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AdminProducts;
